import PropTypes from 'prop-types';
import { useIntl, defineMessages } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { withBlockExtensions } from '@plone/volto/helpers/Extensions';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import { setUIState } from '@plone/volto/actions/form/form';

import ColumnBlocksEditor from './ColumnBlocksEditor';
import View from './View';
import { EditPreviewContext } from '../../../helpers/editPreviewContext';

const messages = defineMessages({
  sidebarTitle: {
    id: 'Column grid block',
    defaultMessage: 'Graella de columnes',
  },
  sidebarHelp: {
    id: 'Column grid sidebar help',
    defaultMessage:
      'Selecciona un bloc dins d’una columna per editar-lo, o fes servir «+ Element» per afegir-ne un de nou.',
  },
  leftColumn: {
    id: 'Column grid left column',
    defaultMessage: 'Columna esquerra',
  },
  rightColumn: {
    id: 'Column grid right column',
    defaultMessage: 'Columna dreta',
  },
});

const Edit = (props) => {
  const {
    data,
    block,
    onChangeBlock,
    selected,
    pathname,
    manage,
    metadata,
    properties,
  } = props;
  const intl = useIntl();
  const dispatch = useDispatch();
  const gridSelected = useSelector((state) => state.form.ui.gridSelected);

  const setGridSelected = (id) => {
    dispatch(setUIState({ gridSelected: id }));
  };

  if (!selected) {
    return (
      <EditPreviewContext.Provider value>
        <View data={data} path={pathname} metadata={metadata || properties} />
      </EditPreviewContext.Provider>
    );
  }

  return (
    <>
      <div className="column-grid-edit">
        <div className="column-grid-edit-columns">
          <ColumnBlocksEditor
            columnId="left"
            columnLabel={intl.formatMessage(messages.leftColumn)}
            data={data}
            block={block}
            onChangeBlock={onChangeBlock}
            pathname={pathname}
            selected={selected}
            manage={manage}
            metadata={metadata}
            properties={properties}
            gridSelected={gridSelected}
            setGridSelected={setGridSelected}
          />
          <ColumnBlocksEditor
            columnId="right"
            columnLabel={intl.formatMessage(messages.rightColumn)}
            data={data}
            block={block}
            onChangeBlock={onChangeBlock}
            pathname={pathname}
            selected={selected}
            manage={manage}
            metadata={metadata}
            properties={properties}
            gridSelected={gridSelected}
            setGridSelected={setGridSelected}
          />
        </div>
      </div>
      <SidebarPortal selected={selected && !gridSelected}>
        <div className="column-grid-sidebar-help">
          <h2>{intl.formatMessage(messages.sidebarTitle)}</h2>
          <p>{intl.formatMessage(messages.sidebarHelp)}</p>
        </div>
      </SidebarPortal>
    </>
  );
};

Edit.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  block: PropTypes.string.isRequired,
  onChangeBlock: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired,
  pathname: PropTypes.string.isRequired,
  manage: PropTypes.bool.isRequired,
  metadata: PropTypes.objectOf(PropTypes.any),
  properties: PropTypes.objectOf(PropTypes.any),
};

export default withBlockExtensions(Edit);
